import { createFileRoute } from "@tanstack/react-router";

import { DocumentTitle } from "@/components";
import { ProductPreviewPage } from "@/modules/product";

export const Route = createFileRoute("/products/list/preview")({
  component: () => (
    <>
      <DocumentTitle
        title="Product Preview"
        description="Preview your product as it will appear on the LAMPU Marketplace."
      />
      <ProductPreviewPage />
    </>
  )
});
